import * as React from "react";
import { Link, Route, Switch, useLocation } from "react-router-dom";
import { ServiceResourceCreation } from "webportalclient";
import { useQuery } from "../../Components/Query";
import { Column, Table } from "../../Components/QueryTable";
import { SortHeader } from "../../Components/SortHeader";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../misc/components/Authorization";
import { DateTimeAccuracy, LocalizedDateTime } from "../../misc/components/LocalizedDateTime";
import { ServiceResourceCreateEditScreen } from "./ServiceResourceCreateEditScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

export const ServiceResourcesTable = () => {
    const { currentUserPermissions } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();
    const { data, refresh } = useQuery();

    const location = useLocation();

    React.useEffect(() => { refresh(); }, [location])

    const menuFormatter = (resource: ServiceResourceCreation) => {
        return (
            <Authorization
                permissionIdsAny={[PermissionEnum.EditDeviceResources]}
                studyId={study.id}
                currentPermissions={currentUserPermissions}>
                <div className="text-center">
                    <div className="btn-group" role="group">
                        <button type="button" className="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <FontAwesomeIcon aria-hidden="true" icon={faBars} />
                        </button>
                        <ul className="dropdown-menu scrollable-menu" role="menu">
                            <Authorization
                                permissionIdsAny={[PermissionEnum.EditDeviceResources]}
                                studyId={study.id}
                                currentPermissions={currentUserPermissions}>
                                <li>
                                    <Link to={`/serviceresources/edit/${resource.id}`}>Edit</Link>
                                </li>
                            </Authorization>
                        </ul>
                    </div>
                </div>
            </Authorization>
        );
    };

    return (
        <Switch>
            <Route path="/ServiceResources" exact>
                <ErrorBoundary>
                    <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.ViewDeviceResources, PermissionEnum.CreateDeviceResources, PermissionEnum.EditDeviceResources]}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <h2 className="text-primary">Service Resources</h2>
                                </div>
                                <div className="col-md-6">
                                    <div className="h2 pull-right">
                                        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.CreateDeviceResources]}>
                                            <Link id="createNew" className="btn btn-primary" to={`/serviceresources/Create`}>Create New</Link>
                                            &nbsp;
                                        </Authorization>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <div id="StudiesTable" className="table-responsive" data-automationid="service-resources-table">
                                                <Table data={data}>
                                                    <Column field="name" header={<SortHeader title="Name" field="name" />} formatter={n => n} />
                                                    <Column field="deviceType" header={<SortHeader title="Service Type" field="devicetype" />} formatter={n => n} />
                                                    <Column field="softwareType" header={<SortHeader title="Resource Type" field="softwaretype" />} formatter={n => n} />
                                                    <Column field="revisionNumber" header={<SortHeader title="Resource Version" field="revisionnumber" />} formatter={n => n} />
                                                    <Column field="lastModifiedDateTime" header={<SortHeader title="Last Modified" field="lastModifiedDateTime" />} formatter={n => <LocalizedDateTime time={n} accuracy={DateTimeAccuracy.Minute} />} />
                                                    <Column field="" formatter={menuFormatter} />
                                                </Table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </Authorization>
                </ErrorBoundary>
            </Route>
            <Route path="/serviceresources/:state/:serviceResourceId?">
                <ErrorBoundary>
                    <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.CreateDeviceResources, PermissionEnum.EditDeviceResources]}>
                        <ServiceResourceCreateEditScreen />
                    </Authorization>
                </ErrorBoundary>
            </Route>
        </Switch>
    );
}
